import { int } from "@goodgamestudios/math-utilities";

import { BasicTutorialController } from "../../../basic/controller/BasicTutorialController";
import { Poker2TutorialController } from "../../controller/Poker2TutorialController";

import MovieClip = createjs.MovieClip;

export class Poker2TutorialAvatarAnimated {
    public static ANIMATED_NOD: number = 1;
    public static ANIMATED_THUMBSUP: number = 2;
    public static ANIMATED_TILT: number = 3;
    public static ANIMATED_TWINKE: number = 4;

    private disp: MovieClip;

    /**
     * @param disp
     */
    constructor(disp: MovieClip) {
        this.disp = disp;
    }

    public animated(frameNo: number = 0): void {
        if (!frameNo) {
            switch (this.tutorialController.tutorialState) {
                case BasicTutorialController.TUT_STATE_WELCOME:
                    this.disp.gotoAndStop(1);
                    this.disp.mc_animated.play();
                    break;
                case "tut_step10_alinaFold":
                    this.disp.gotoAndStop(3);
                    this.disp.mc_animated.play();
                    break;
                case "tut_step20_handStrength":
                    this.disp.gotoAndStop(4);
                    this.disp.mc_animated.play();
                    break;
                case "tut_step34_victory":
                    this.disp.gotoAndStop(2);
                    this.disp.mc_animated.play();
                    break;

                default:
                    if (Math.random() < .1) {
                        frameNo = int((Math.random() < .5) ? 3 : 4);
                        this.disp.gotoAndStop(frameNo);
                        this.disp.mc_animated.play();
                    }
                    else {
                        this.disp.gotoAndStop(1);
                    }
                    break;
            }
        }

        /*
        come soon
        if (!frameNo)
        {
            frameNo = int(Math.random()*4)+1;
        }
        disp.gotoAndStop(frameNo);
        disp.mc_animated.play();
        */
    }

    protected get tutorialController(): Poker2TutorialController {
        return Poker2TutorialController.getInstance();
    }

    //
    // end
    //
}
